import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import { ReducerStatus, RootState } from '../types';
import { PreCheckoutState } from './types';
import { trackClarity } from '@/tracking/clarity';
import { ClarityEvent } from '@/tracking/clarity/types';

const initialState: PreCheckoutState = {
    status: ReducerStatus.INITIAL,
    showErrors: false,
    data: {
        ProductGroups: null,
        TotalPrice: { Amount: 0, Currency: '' },
    },
};

const state: PreCheckoutState = {
    ...initialState,
};

const getters: GetterTree<PreCheckoutState, RootState> = {
    getProductGroups(state) {
        return state.data.ProductGroups;
    },
};

const actions: ActionTree<PreCheckoutState, RootState> = {
    setPreCheckoutLoading({ state, commit }) {
        commit('setPreCheckoutState', {
            ...state,
            status: ReducerStatus.LOADING,
        });
    },

    setPreCheckoutUpdating({ state, commit }) {
        commit('setPreCheckoutState', {
            ...state,
            status: ReducerStatus.UPDATING,
        });
    },

    setPreCheckoutLoaded({ state, commit }) {
        commit('setPreCheckoutState', {
            ...state,
            status: ReducerStatus.LOADED,
        });
    },

    setPreCheckoutSuccess({ state, commit }, payload) {
        commit('setPreCheckoutState', {
            ...state,
            status: ReducerStatus.LOADED,
            data: payload,
        });
    },

    setPreCheckoutError({ state, commit }) {
        trackClarity(ClarityEvent.PRE_CHECKOUT_INITIAL_ERROR);

        commit('setPreCheckoutState', {
            ...state,
            status: ReducerStatus.ERROR,
        });
    },

    setShowErrors({ commit }, payload) {
        commit('setShowErrors', payload);
    },
};

const mutations: MutationTree<PreCheckoutState> = {
    setPreCheckoutState(state, payload) {
        state.data = payload.data;
        state.status = payload.status;
    },
    setShowErrors(state, payload) {
        state.showErrors = payload;
    },
};

export const preCheckout: Module<PreCheckoutState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
